import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Response } from "@angular/http"
import { Observable } from 'rxjs';
import { User } from '../../model/user.model';
import { BehaviorSubject } from 'rxjs';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { JwtService } from '../../auth/jwt.service';
import { DataSharingService } from '../../auth/data-sharing.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Key } from 'protractor';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TenderingService {

  //readonly rootUrl = "";
  readonly rootUrl = environment.baseUrl;

  constructor(private http: HttpClient, private jwtService: JwtService,
    private dataSharingService: DataSharingService) { }

    GetEnquiryList() {
      return this.http.get(this.rootUrl + '/api/Tendering/GetEnquiryList');
    }

    GetEnquiryById(id) {

      const enquiry = {
        enquiryId : id
      }

      return this.http.post(this.rootUrl + '/api/Tendering/getEnquiryById', enquiry);
    }

    InviteTechQuote(form)
    {
      return this.http.post(this.rootUrl + '/api/Tendering/InviteTechQuote', form);
    }

    InvitePriceQuote(form)
    {
      return this.http.post(this.rootUrl + '/api/Tendering/InvitePriceQuote', form);
    }

    InviteTechPriceQuote(form)
    {
      return this.http.post(this.rootUrl + '/api/Tendering/InviteTechPriceQuote', form);
    }

    ReinviteQuote(form)
    {
      return this.http.post(this.rootUrl + '/api/Tendering/ReinviteQuote', form);
    }

    GetEnquiryQuotesdata() {
      return this.http.get(this.rootUrl + '/api/Tendering/GetEnquiryQuotesdata');
    }

    GetEnquiryQuotesById(id) {

      const enquiry = {
        enquiryId : id
      }
      return this.http.post(this.rootUrl + '/api/Tendering/GetEnquiryQuotesById', enquiry);
    }

    SubmitTechQuote(form)
    {
      return this.http.post(this.rootUrl + '/api/Tendering/SubmitTechQuote', form);
    }

    SubmitPriceQuote(form)
    {
      return this.http.post(this.rootUrl + '/api/Tendering/SubmitPriceQuote', form);
    }

    SubmitTechPriceQuote(form)
    {
      alert("working");
      return this.http.post(this.rootUrl + '/api/Tendering/SubmitTechPriceQuote', form);
    }

    GetSubmittedQuotes() {
      return this.http.get(this.rootUrl + '/api/Tendering/GetSubmittedQuotes');
    }
    searchEnquiry(keywrd){
      const key = {
        keyword : keywrd
      }
      return this.http.post(this.rootUrl + '/api/Tendering/SearchEnquiry', key);
    }
    GetAssignedQuotes() {
      return this.http.get(this.rootUrl + '/api/Tendering/GetAssignedQuotes');
    }
    EnqSubmittedSearch(keywrd){
      const key={
        keyword:keywrd
      }
      return this.http.post(this.rootUrl + '/api/Tendering/EnqSubmittedSearch', key);
    }
    EnqListVendorSearch(keywrd){
      const key={
        keyword:keywrd

      }
      return this.http.post(this.rootUrl +'/api/Tendering/EnqListVendorSearch',key);
    }
    SmtVendQuoteSearch(keywrd){
      const key={
        keyword:keywrd

      }
      return this.http.post(this.rootUrl +'/api/Tendering/SmtVendQuoteSearch',key);

    }
    searchvendormessage(){

      return this.http.get(this.rootUrl +'/api/Tendering/searchvendormessage');
    }
    GetVendorsList() {
      return this.http.get(this.rootUrl + '/api/Tendering/GetVendorsList');
    }
}
